import { render, staticRenderFns } from "./SettingLayout.vue?vue&type=template&id=26bff5b3&scoped=true&"
import script from "./SettingLayout.vue?vue&type=script&lang=js&"
export * from "./SettingLayout.vue?vue&type=script&lang=js&"
import style0 from "./SettingLayout.vue?vue&type=style&index=0&id=26bff5b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bff5b3",
  null
  
)

export default component.exports